<template>
  <div class="article-detail-page">
    <SubPageHeader title="文章详情" />
    <div class="content">
      <div v-if="isLoading" class="state-text">加载中...</div>
      <div v-else-if="!detailData" class="state-text">暂无文章详情数据</div>
      <div v-else class="detail-card">
        <div class="detail-title">{{ getDetailTitle(detailData) }}</div>
        <div class="detail-time">{{ getDetailDate(detailData) }}</div>
        <img
          v-if="getDetailImage(detailData)"
          :src="getDetailImage(detailData)"
          class="detail-image"
          alt="文章图片"
        >
        <div v-if="getDetailContent(detailData)" class="detail-content" v-html="getDetailContent(detailData)"></div>
        <div v-else class="detail-empty">暂无正文内容</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getArticleDetail } from '@/api';
import toast from '@/components/toast';
import SubPageHeader from '../component/SubPageHeader.vue';

const DETAIL_PARAM_KEYS = ['articleId', 'id', 'article_id', 'content_id', 'record_id'];
const DETAIL_TITLE_KEYS = ['title', 'article_title', 'name'];
const DETAIL_DATE_KEYS = ['publishedAt', 'createdAt', 'publish_time', 'published_at', 'create_time', 'created_at', 'date'];
const DETAIL_IMAGE_KEYS = ['coverUrl', 'cover', 'cover_url', 'image', 'img', 'thumb', 'pic'];
const DETAIL_CONTENT_KEYS = ['content', 'article_content', 'detail', 'body'];

export default {
  name: 'ArticleDetailPage',
  components: {
    SubPageHeader,
  },
  data() {
    return {
      isLoading: false,
      detailData: null,
    };
  },
  mounted() {
    this.fetchArticleDetail();
  },
  methods: {
    getMatchedValue(item, keys, fallback = '') {
      for (let index = 0; index < keys.length; index += 1) {
        const value = item?.[keys[index]];
        if (value !== undefined && value !== null && value !== '') {
          return value;
        }
      }
      return fallback;
    },
    buildDetailParams() {
      const articleId = this.getMatchedValue(this.$route.query, DETAIL_PARAM_KEYS, '');
      return articleId ? { articleId } : {};
    },
    normalizeDetail(payload) {
      if (!payload) {
        return null;
      }
      if (Array.isArray(payload)) {
        return payload[0] || null;
      }
      if (payload?.detail && typeof payload.detail === 'object') {
        return payload.detail;
      }
      if (payload?.info && typeof payload.info === 'object') {
        return payload.info;
      }
      return payload;
    },
    getDetailTitle(detail) {
      return this.getMatchedValue(detail, DETAIL_TITLE_KEYS, '文章详情');
    },
    getDetailDate(detail) {
      return this.getMatchedValue(detail, DETAIL_DATE_KEYS, '--');
    },
    getDetailImage(detail) {
      return this.getMatchedValue(detail, DETAIL_IMAGE_KEYS, '');
    },
    getDetailContent(detail) {
      let content = this.getMatchedValue(detail, DETAIL_CONTENT_KEYS, '');
      if (content && typeof content === 'string') {
        // 修复 <a> 标签 href 缺少 http/https 协议的问题
        content = content.replace(/<a\s+[^>]*href=["']([^"']*)["'][^>]*>/gi, (match, url) => {
          let trimmedUrl = url.trim();
          if (trimmedUrl && !/^(https?:\/\/|ftp:\/\/|mailto:|tel:|javascript:|\/|#)/i.test(trimmedUrl)) {
            // 将原匹配到的字符串中的原始url替换为带上http://的url
            return match.replace(url, `http://${trimmedUrl}`);
          }
          return match;
        });
      }
      return content;
    },
    async fetchArticleDetail() {
      const params = this.buildDetailParams();
      this.isLoading = true;
      try {
        const res = await getArticleDetail(params);
        this.detailData = this.normalizeDetail(res?.data);
      } catch (error) {
        this.detailData = null;
        if (Object.keys(params).length === 0) {
          toast('缺少文章详情参数，请从文章列表进入详情');
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.article-detail-page {
  min-height: 100vh;
  background: #ffffff;
}

.content {
  padding: 3.58974vw;
}

.state-text {
  padding: 10.25641vw 0;
  text-align: center;
  color: #999;
  font-size: 3.84615vw;
}

.detail-title {
  font-size: 5.12821vw;
  color: #1f1f1f;
  line-height: 1.5;
  font-weight: 700;
}

.detail-time {
  margin-top: 2.05128vw;
  font-size: 3.33333vw;
  color: #999;
}

.detail-image {
  margin-top: 3.07692vw;
  width: 100%;
  border-radius: 2.5641vw;
}

.detail-content {
  margin-top: 3.58974vw;
  font-size: 3.84615vw;
  color: #1f1f1f;
  line-height: 1.8;
  word-break: break-word;

  :deep(video),
  :deep(img),
  :deep(iframe) {
    max-width: 100%;
    height: auto;
  }
}

.detail-empty {
  margin-top: 3.58974vw;
  font-size: 3.58974vw;
  color: #999;
}
</style>
